import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { ContactCardComponent } from './contact-card/contact-card.component';
import { EmailComposerComponent } from './email-composer/email-composer.component'

@NgModule({
  imports: [
    ContactCardComponent
  ],
  exports: [
    ContactCardComponent
  ]
})
export class UtilModule { }
